import React, { useState, useEffect } from 'react';
import './Sidebar.css';
import PropTypes from 'prop-types';
import logoSvg from '../../images/logo.svg';
import SocialMediaButtons from '../SocialMediaButtons/SocialMediaButtons';

const Sidebar = (props) => {
  const { isExpanded, sidebarData } = props;
  const { items } = sidebarData;
  const [state, setState] = useState(null);
  const [searchKey, setSearchKey] = useState(isExpanded);

  useEffect(() => {
    const width = window?.innerWidth;
    if (isExpanded) {
      setState('opened');
      switch (width) {
        case width <= 960:
          document.body.style.marginLeft = '300px';
          break;
        case width <= 320:
        default:
          document.body.style.marginLeft = '265px';
          break;
      }
    } else {
      setState(null);
      document.body.style.transition = '0.5s';
      document.body.style.marginLeft = '0';
    }
  }, [isExpanded]);

  const handleSubmit = () => {
    window.open(`https://lykon.de/search?q=${searchKey}`);
  };

  const onSearchChange = (event) => {
    event.preventDefault();
    setSearchKey(event.target.value);
  };

  return (
    <div className={`sidebar ${state}`}>
      <a className="title__logo" href="/">
        <img src={logoSvg} alt="logo" />
      </a>
      <form className="search__form" onSubmit={() => handleSubmit()}>
        <input
          placeholder="Suchen"
          type="text"
          className="form__input"
          onChange={(event) => onSearchChange(event)}
        />
      </form>
      {items.map(({ id, url, text }) => {
        return (
          <a href={url} key={id}>
            {text}
          </a>
        );
      })}
      <a href="https://dashboard.lykon.de">Login</a>
      <SocialMediaButtons fromSidebar />
    </div>
  );
};

Sidebar.propTypes = {
  isExpanded: PropTypes.bool,
  sidebarData: PropTypes.shape({
    id: PropTypes.string,
    category: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        text: PropTypes.string,
      })
    ),
  }),
};

Sidebar.defaultProps = {
  isExpanded: false,
  sidebarData: {},
};

export default Sidebar;
